/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Picker_Children_LabelInputs */

const en_guest_picker_children_label = /** @type {(inputs: Guest_Picker_Children_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Children`)
};

/**
* | output |
* | --- |
* | "Children" |
*
* @param {Guest_Picker_Children_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_children_label = /** @type {((inputs?: Guest_Picker_Children_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Children_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_children_label(inputs)
});